// extracted by mini-css-extract-plugin
module.exports = {"efCollectionPCB":"B_efCollectionPCB__XrCcl"};